import { render, staticRenderFns } from "./PollutionDetail.vue?vue&type=template&id=532f3b06&scoped=true&"
import script from "./PollutionDetail.vue?vue&type=script&lang=js&"
export * from "./PollutionDetail.vue?vue&type=script&lang=js&"
import style0 from "./PollutionDetail.vue?vue&type=style&index=0&id=532f3b06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f3b06",
  null
  
)

export default component.exports